import React from 'react'
import { generalFilter, useDefaultColumn } from '../../../../../util/filter';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useExpanded, useFilters, useGlobalFilter, useSortBy, useTable } from 'react-table';
import { Grid, IconButton, MenuItem, Paper, Select, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@material-ui/core';
import MuiTable from "@material-ui/core/Table";

import { Edit } from "@material-ui/icons";
import { EolUnitsTable } from './EolUnitsTable';
import { formatDate } from '../../../../common/formatDate';
import { toast } from 'react-toastify';
import { getTheme } from '../../../../common/getLocalTheme';
import { useFetchContext } from '../../../../common/FetchContext';
import { useUpdateEolDisposition } from '../opsQueuesQueries';


export const EolProjectTable = ({ data, EolDispositionData, refetch }: any) => {


    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const { authAxios } = useFetchContext();
    const { mutateAsync: mutateEolDispositionUpdate } = useUpdateEolDisposition();



    const columns = React.useMemo(
        () => [

            {
                Header: "Id",
                accessor: "project_id",
            },
            {
                Header: () => null, // No header
                id: "expander", // It needs an ID
                Cell: ({ row }: any) => (
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? (
                            <KeyboardArrowDownIcon />
                        ) : (
                            <KeyboardArrowUpIcon />
                        )}
                    </span>
                ),
            },

            {

                id: "Project Number",
                accessor: "project_number",
                filter: generalFilter,

                Cell: ({ cell, row }: any) => {
                    console.log("Data", JSON.stringify(row.value));

                    return (
                        <div>
                            {row.original.project_number ? row.original.project_number : "N/A"}
                        </div>

                    );
                },

            },
            {
                id: "Work Order Name",
                accessor: "name",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    const workOrder = row.original;

                    const handleAction = () => {
                        console.log("Clicked:", workOrder);
                    };

                    return (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Typography variant="body2">
                                {row.original.name ? row.original.name : "N/A"}
                            </Typography>


                        </div>
                    );
                }
            },


            {
                id: "Disposition",
                accessor: "disposition_name",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    const workOrderId = row.original.id

                    const handleChange = async (e: any) => {
                        var newDisposition = e.target.value as string
                        try {
                            await mutateEolDispositionUpdate({
                                authAxios,
                                id: workOrderId,
                                disposition: newDisposition,
                            });

                            console.log(newDisposition);
                            toast.success("EOL disposition status updated successfully");
                            if (refetch) {
                                await refetch();
                            }
                        } catch (error) {
                            console.error("Failed to update EOL disposition:", error);
                            toast.error("Failed to update EOL disposition status");

                        }

                    }


                    return (
                        <Select
                            key={row.original.id}
                            labelId="disposition_select"
                            id="disposition_select"
                            disableUnderline
                            value={row.original.disposition}
                            label="Disposition"
                            disabled={getTheme()}
                            onChange={handleChange}
                        >
                            {EolDispositionData?.map((disposition: any) => (
                                <MenuItem key={disposition.id}
                                    value={disposition.url}>
                                    {disposition.name}
                                </MenuItem>
                            ))}
                        </Select>
                    );
                },
            },

            {
                id: "Customer",
                accessor: "customer_name",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.customer_name ? row.original.customer_name : "N/A"}
                        </div>
                    );
                }
            },

            {
                id: "EOL Ready Date",
                accessor: "eol_ready_on",
                Cell: ({ row }: any) => {
                    return (

                        <Typography variant="body2"> {row.original.eol_ready_on ? formatDate(row.original.eol_ready_on) : "N/A"} </Typography>
                    );
                },
            },
            {
                id: "Days Since EOL Ready",
                accessor: "days_since_eolready",
                width: 300,
                minWidth: 250,
                maxWidth: 400,
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.days_since_eolready ? row.original.days_since_eolready : "N/A"}
                        </div>
                    );
                }
            },




        ],
        []
    );

    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data,
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["project_id", "sfdc_number", "Dispositions"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,
            useExpanded
        );

    return (
        <>
            <TableContainer
                data-testid="tableContainer"
                // style={theme.tableContainer}
                component={Paper}
            >
                <MuiTable stickyHeader {...getTableProps()} size="small">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell style={theme.noLeftRightPadding}>
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <Grid item xs={12} {...column.getHeaderProps()}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={0}
                                                >
                                                    <Typography variant="subtitle2">
                                                        {(column.id === "Intake Directives" ||
                                                            column.id === "Notes" ||
                                                            column.id === "Add Tasks") &&
                                                            column.render("Header")}
                                                    </Typography>
                                                    {column.canFilter ? column.render("Filter") : null}
                                                    <Grid item xs={2}>
                                                        <IconButton
                                                            type="submit"
                                                            aria-label="search"
                                                            size="small"
                                                            {...column.getSortByToggleProps()}
                                                        >
                                                            {column.isSorted ? (
                                                                column.isSortedDesc ? (
                                                                    <ArrowDropDownIcon />
                                                                ) : (
                                                                    <ArrowDropUpIcon />
                                                                )
                                                            ) : (
                                                                column.id !== "expander" &&
                                                                column.id !== "Intake Directives" &&
                                                                column.id !== "Notes" &&
                                                                column.id !== "Add Tasks" && <CallSplitIcon />
                                                            )}
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <>
                                    <TableRow {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <TableCell {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>

                                    {row.isExpanded ? (
                                        <TableRow>
                                            <TableCell colSpan={visibleColumns.length}>
                                                <EolUnitsTable tableData={(row.original as any).units} />
                                            </TableCell>
                                        </TableRow>
                                    ) : null}
                                </>
                            );
                        })}
                    </TableBody>
                </MuiTable>
            </TableContainer>

        </>
    )
}


